import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const EventsFilter = ({ filters, currentFilter, onFilter }) => (
  <div className="absolute top-1 right-0 md:right-6 lg:right-14 lg:top-12">
    {filters.map(({ key, label }) => (
      <button
        key={key}
        className={classnames(
          'bg-transparent text-base font-semibold mr-4 hover:opacity-80 focus:outline-none',
          {
            'underline text-white': currentFilter === key,
            'text-gray-400': currentFilter !== key,
          }
        )}
        onClick={() => onFilter(key)}
      >
        {label}
      </button>
    ))}
  </div>
)

EventsFilter.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  currentFilter: PropTypes.string.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default EventsFilter
